import React, { createRef, forwardRef, useState } from 'react'
import { Input, Modal, notification, Switch } from 'antd'
import { cloneJob, forceFailJob } from '@halo/api/brine.api'
import { ModalFuncProps } from 'antd/lib/modal'

const DEFAULT_ACTION_MODAL_PROPS: Partial<ModalFuncProps> = {
    okText: 'Continue',
    okButtonProps: {
        className: 'job-confirmation-modal-ok-btn',
        size: 'small',
    },
    cancelButtonProps: {
        className: 'job-confirmation-modal-cancel-btn',
        size: 'small',
    },
}

export const handleJobMarkAsFailed = (job: any, onComplete: (ok: boolean, job: any) => void) => {
    Modal.confirm({
        ...DEFAULT_ACTION_MODAL_PROPS,
        title: 'Mark Job as Failed',
        content: (
            <>
                <p>Are you sure you want to set the following job to status "FAILED"?</p>
                <p>
                    <b>Name:</b> {job.name}
                    <br />
                    <b>ID:</b> {job.id}
                    <br />
                </p>
            </>
        ),
        onOk: async (...args: any[]) => {
            const res = await forceFailJob(job.id, {})

            if (res.ok) {
                notification.success({
                    message: '',
                    description: 'Job successfully marked as failed.',
                })

                return onComplete(res.ok, res.data)
            } else {
                notification.error({
                    message: '',
                    description: 'We were unable to mark job as failed. See console for more details.',
                })

                console.warn(res)
                return false
            }
        },
        onCancel: () => onComplete(false, null),
    })
}

const JobCloneDialog = forwardRef<Input, { job: any }>(({ job }, ref) => {
    const [rename, setRename] = useState(false)
    const [tmpName, setTmpName] = useState(job.name)

    return (
        <>
            <p>Are you sure you want to clone the following job?</p>
            <p>
                <b>Name:</b> {job.name}
                <br />
                <b>ID:</b> {job.id}
                <br />
            </p>
            <div className="switch-row">
                <div className="switch-left">
                    <Switch
                        size="small"
                        checked={rename}
                        onChange={(checked) => {
                            setRename(checked)
                            if (!checked) {
                                setTmpName(job.name)
                            }
                        }}
                    />
                </div>
                <div className="switch-right">Change new job name</div>
            </div>
            <div>
                <Input
                    ref={ref}
                    size="small"
                    disabled={!rename}
                    defaultValue={job.name}
                    value={tmpName}
                    onChange={(ev) => setTmpName(ev.target.value)}
                />
            </div>
        </>
    )
})

export const handleJobClone = (job: any, onComplete: (ok: boolean, job: any) => void) => {
    const inputRef = createRef<Input>()

    Modal.confirm({
        ...DEFAULT_ACTION_MODAL_PROPS,
        title: 'Clone Job',
        content: <JobCloneDialog job={job} ref={inputRef} />,
        onOk: async () => {
            const newName = inputRef.current.input.value ?? job.name
            const res = await cloneJob(job.id, newName, {})

            if (res.ok) {
                notification.success({
                    message: '',
                    description: 'Job successfully cloned.',
                })

                return onComplete(res.ok, res.data)
            } else {
                notification.error({
                    message: '',
                    description: 'We were unable to clone the requested job. See console for more details.',
                })

                console.warn(res)
                return false
            }
        },
        onCancel: () => onComplete(false, null),
    })
}
